import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types";

const TIGGER_TEXT_BOTTOM_BORDER = "1px";

export const CartHalfCardHeaderWrapper = styled.div(({ theme }) => ({
    display: "flex",
    padding: `${theme.spacing.large} ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.large}`,
    alignItems: "center",
}));

export const CartHeaderWrapper = styled.div<{ isAlignCenter: boolean }>(({ theme, isAlignCenter }) => ({
    display: "flex",
    padding: `${theme.spacing.large} ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.medium}`,
    alignItems: isAlignCenter ? "flex-start" : "center",
}));

export const ImageWrapper = styled.div<{ isMarginTop?: boolean; height: string; width: string }>(
    ({ theme, isMarginTop = false, height, width }) => ({
        height: height,
        width: width,
        marginRight: theme.spacing.xSmall,
        marginTop: isMarginTop ? theme.spacing.xxSmall : 0,
        "& > img": {
            borderRadius: theme.cornerRadius.rounded,
        },
    }),
);

export const RxNameWrapper = styled.div(({ theme }) => ({
    display: "flex",
    "& img": {
        width: "24px",
        flexShrink: 0,
        height: "24px",
        borderRadius: theme.cornerRadius.rounded,
    },
}));

export const ButtonWrapper = styled.div(({ theme }) => ({
    paddingTop: theme.spacing.small,
    paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.x3})`,
    marginLeft: theme.spacing.medium,
    marginRight: theme.spacing.medium,
}));

export const NameWrapper = styled.div(({ theme }) => ({
    flex: 2,
    marginRight: theme.spacing.x6,
}));

export const SeparatorWrapper = styled.div(({ theme }) => ({
    padding: `0 ${theme.spacing.small}`,
    display: "flex",
}));

export const HalfCardSeparatorWrapper = styled.div(({ theme }) => ({
    width: "100%",
    height: "1px",
    background: theme.colors[theme.colorMode].background_Disabled,
}));

export const StyledText = styled(Text)<{ textColor?: keyof IColors }>(({ textColor, theme }) => ({
    color: textColor ? theme.colors[theme.colorMode][textColor] : theme.colors[theme.colorMode].text_Med_Emphasis,
    display: "flex",
    textDecoration: "underline",
}));

export const ExpressIconWrapper = styled.div(({ theme }) => ({
    marginRight: theme.spacing.xxSmall,
}));

export const SlaText = styled.div(({ theme }) => ({
    marginLeft: theme.spacing.xxSmall,
}));

export const RxName = styled.div<{ isMarginTop?: boolean }>(({ theme, isMarginTop = false }) => ({
    marginTop: isMarginTop ? theme.spacing.xxSmall : 0,
    display: "flex",
    alignItems: "center",
}));

export const TriggerTextContainer = styled(Text)<{ hideBorder?: boolean }>`
    display: inline-block;
    border-bottom: ${(props) => `${TIGGER_TEXT_BOTTOM_BORDER} dashed ${props.theme.colors.light.text_Med_Emphasis}`};
`;

export const CommsText = styled(Text)(({ theme }) => ({
    marginRight: theme.spacing.xxSmall,
}));

export const RxNameText = styled(Text)<{ bottomMessagePresent?: boolean }>(
    ({ theme, bottomMessagePresent = false }) => ({
        marginTop: bottomMessagePresent ? 0 : theme.spacing.xxxSmall,
    }),
);
